export enum PlannerName {
  None = 'None',
  Bakery = 'Bakery',
  HotFood = 'HotFood',
}
